export default __webpack_public_path__ + "static/media/logo-ticketmaster.b1bbc788.svg";